<script setup>
  import { ref, watchEffect, watch, useTemplateRef } from 'vue';
  import useLegacyBridge from "@/composables/useLegacyBridge";
  import { useUpdateKey } from '@/composables/useUpdateKey';

  const props = defineProps({
    containerSettings: {
      type: Object,
      required: true,
    },
    mapName: {
      type: String,
      required: true,
    },
    containerId: {
      type: Number,
      required: true,
    },
  });

  const mapRef = useTemplateRef('map-ref');
  const legendRef = useTemplateRef('legend-ref');

  const { cosmos } = useLegacyBridge();
  const updateKey = useUpdateKey();

  const cosmosUI = ref(null);

  const uiOptions = {
      useJwxUI: false,
      tempestMeta: true,
      viewId: `v-${props.containerId}`,
      miniGraphOptions: {
          showModelData: false,
          extents: [-4, 4],
      },
      uiElements: [
          jweather.UIElements.LEGEND,
      ],
      regionalProducts: {
          products: jweather.RegionalProducts.ALLOWED_PRODUCTS,
      },
      legend: {
        allowClose: false,
        obsLegend: {
            isHurrnet: false
        }
      }   
    };

    const mapOptions = {
      "searchType": "search",
      "zoom": props.containerSettings?.zoom || 6,
      "width": "100%",
      "height": "100%",
      "lat": props.containerSettings?.lat || '',
      "lon": props.containerSettings?.lon || '',
      "enableArbitraryMarkers": true
    };       

    function loadCosmos() {
      mapRef.value.innerHTML = "";
      legendRef.value.innerHTML = "";
      uiOptions.viewId = `v-${props.containerId}`;
      uiOptions.regionalProducts.productSettings = { [`v-${props.containerId}`]: createView() };
      uiOptions.legend.targetSelector = `[data-map=legend-${props.containerId}]`;

      cosmosUI.value = cosmos(mapRef.value, uiOptions, mapOptions)
    }

    function createView() {
      const view = {};
      view.name = 'Saved Map';
      view.description = 'A map saved to your profile.';
      view.mapMode = props.containerSettings?.mapMode || 'obs';
      view.overlays = props.containerSettings?.overlays || {};
      return view;
    }

    watchEffect(() => {
      if (mapRef.value) loadCosmos();
    });

    watch(updateKey.key, () => {
      mapRef.value = null;
      loadCosmos();
    })

</script>

<template>
  <div
    ref="map-ref"
    :id="`favortied-map-${props.containerId}`"
    class="jwx-favorited-map"
    style="height: 400px; width: 100%; overflow: hidden; position: relative;"
  ></div>
  <div
    ref="legend-ref"
    class="jwx-favorited-map__legend"
    :data-map="`legend-${props.containerId}`">
  </div>
</template>